import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "agent_container" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["src"]

import CustomHeader from '@/themes/themeTwo/components/common/customHeader.vue';
import { ref, computed, watch } from 'vue'
import InvitationView from './components/invitationView.vue';
import MyDataView from './components/myDataView.vue';
import CommissionView from './components/commissionView.vue';
import DetailsView from './components/detailsView.vue';
import FaqView from './components/faqView.vue';
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity';
import { AgentData, TAB_LIST } from '@/view/agent/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'agentPopup',
  props: {
    dataSet: {}
  },
  emits: ['onClickTab', 'close', 'update:show'],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const show = ref(false)

const tabList = ref(TAB_LIST)
const activeTab = ref(0)
const emit = __emit

const props = __props

const active = ref(props.dataSet.activeTab)

watch(active, (val) => {
    emit('update:show', val)
})

const close = () => {
    emit('close')
}
const onClickTab = (value: any) => {
    console.log('value>>',value);
    emit('onClickTab', value)
}


return (_ctx: any,_cache: any) => {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
    position: "bottom",
    "overlay-style": { overflow: 'hidden' },
    style: {
        minWidth: '100%',
        minHeight: '100%',
        color: '#fff',
        zIndex: '1998'
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CustomHeader, {
          text: "Agente",
          isPopupCloseBackIcon: true,
          onClosePopup: close
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.dataSet.bannerImage,
            alt: ""
          }, null, 8, _hoisted_3),
          _createVNode(_component_van_tabs, {
            modelValue: active.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
            sticky: "",
            ellipsis: false,
            onClickTab: onClickTab
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_tab, {
                  key: index,
                  title: _ctx.$t(item.name),
                  name: index
                }, null, 8, ["title", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        (_ctx.dataSet.activeTab == 0)
          ? (_openBlock(), _createBlock(InvitationView, {
              key: 0,
              onClosePoup: close
            }))
          : _createCommentVNode("", true),
        (_ctx.dataSet.activeTab == 1)
          ? (_openBlock(), _createBlock(MyDataView, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.dataSet.activeTab == 2)
          ? (_openBlock(), _createBlock(CommissionView, { key: 2 }))
          : _createCommentVNode("", true),
        (_ctx.dataSet.activeTab == 3)
          ? (_openBlock(), _createBlock(DetailsView, { key: 3 }))
          : _createCommentVNode("", true),
        (_ctx.dataSet.activeTab == 4)
          ? (_openBlock(), _createBlock(FaqView, { key: 4 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})